module.exports = __webpack_public_path__ + "static/media/hall-PAL.87b56e67.svg";